import { useParams } from "react-router-dom";
import { HolyWheelLoading } from "../../../HolyWheelPage/components/HolyWheelLoading/HolyWheelLoading";

export function WheelCampaignFallback() {
    const { wheelCode = "holy-wheel" } = useParams();
    return wheelCode === "holy-wheel" ? <HolyWheelLoading /> : null;
}
